export default "__VITE_ASSET__BKdUETwy__"